var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellTrakLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3987 16.1455H0.7C0.31508 16.1455 0 15.8295 0 15.4435V0.873751C0 0.39314 0.392 0 0.870897 0H15.3987C15.7836 0 16.0987 0.315996 16.0987 0.702035V15.4435C16.0987 15.8295 15.7836 16.1455 15.3987 16.1455V16.1455Z",
    fill: "#EE7203"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0913 16.1455H19.3926C19.0074 16.1455 18.6926 15.8295 18.6926 15.4435V0.873751C18.6926 0.39314 19.0846 0 19.5632 0H34.0913C34.4763 0 34.7913 0.315996 34.7913 0.702035V15.4435C34.7913 15.8295 34.4763 16.1455 34.0913 16.1455V16.1455Z",
    fill: "#7FA0F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3987 34.8543H0.7C0.31508 34.8543 0 34.5383 0 34.1522V19.5822C0 19.1016 0.392 18.7087 0.870897 18.7087H15.3987C15.7836 18.7087 16.0987 19.0247 16.0987 19.4108V34.1522C16.0987 34.5383 15.7836 34.8543 15.3987 34.8543V34.8543Z",
    fill: "#7FA0F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0913 34.8543H19.3926C19.0074 34.8543 18.6926 34.5383 18.6926 34.1522V19.5822C18.6926 19.1016 19.0846 18.7087 19.5632 18.7087H34.0913C34.4763 18.7087 34.7913 19.0247 34.7913 19.4108V34.1522C34.7913 34.5383 34.4763 34.8543 34.0913 34.8543V34.8543Z",
    fill: "#7FA0F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellTrakLogo);
export default __webpack_public_path__ + "static/media/CellTrak-logo.184dead4eea03e7a62f827322d558493.svg";
export { ForwardRef as ReactComponent };